import React from 'react'
import { Divider, Grid, Typography } from '@material-ui/core'
import useStyles from './styles'

export const DadosEspecificos = (props) => {
  const classes = useStyles()
  const { valores, tipoVestigioGenerico, dadosDescricaoTecnicaPai = null, tipoVestigioEspecifico = null, tipoExame } = props
  return (
    <div style={{ width: '100%' }}>
      {tipoVestigioGenerico === 'BALISTICO' && ['ARMA_DE_FOGO', 'ARMA_DE_PRESSAO'].includes(tipoVestigioEspecifico) && (
        <>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>DADOS DE IDENTIFICAÇÃO</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
            <Grid item md={3} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>TIPO</b>
              </Typography>
              <Typography variant="body2">{valores.tipo?.id ? valores.tipo.nome?.toUpperCase() : valores.tipo?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>MARCA</b>
              </Typography>
              <Typography variant="body2">{valores.marca?.id ? valores.marca.nome?.toUpperCase() : valores.marca?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>MODELO</b>
              </Typography>
              <Typography variant="body2">{valores.modelo?.id ? valores.modelo.nome?.toUpperCase() : valores.modelo?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>CALIBRE NOMINAL</b>
              </Typography>
              <Typography variant="body2">{valores.calibreNominal?.id ? valores.calibreNominal.nome?.toUpperCase() : valores.calibreNominal?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>DADOS DE ORIGEM</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
            <Grid item md={12} sm={12} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>LOCAL DE FABRICAÇÃO</b>
              </Typography>
              <Typography variant="body2">{valores.locFabs?.map((locFab) => locFab?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>NUMERAÇÃO DE SÉRIE</b>
              </Typography>
              <Typography variant="body2">{valores.numeracaoDeSerie?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={8} sm={8} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE</b>
              </Typography>
              <Typography variant="body2">{valores.locGravNumSers?.map((locGravNumSer) => locGravNumSer?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>NUMERAÇÃO DE MONTAGEM</b>
              </Typography>
              <Typography variant="body2">{valores.numeracaoDeMontagem?.toUpperCase() === 'OUTRO' ? valores.numeracaoDeMontagemInput.toUpperCase() : valores.numeracaoDeMontagem?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={8} sm={8} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE MONTAGEM</b>
              </Typography>
              <Typography variant="body2">{valores.locGravNumMons?.map((locGravNumMon) => locGravNumMon?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>CARACTERÍSTICAS DE OPERAÇÃO</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>SISTEMA DE PERCUSSÃO</b>
              </Typography>
              <Typography variant="body2">{valores.sisPercs?.map((sisPerc) => sisPerc?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>SISTEMA DE CARREGAMENTO</b>
              </Typography>
              <Typography variant="body2">{valores.sisCarrs?.map((sisCarr) => sisCarr?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>SISTEMA DE FUNCIONAMENTO</b>
              </Typography>
              <Typography variant="body2">{valores.sistemaFuncionamento?.id ? valores.sistemaFuncionamento.nome?.toUpperCase() : valores.sistemaFuncionamento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>ALMA DO CANO</b>
              </Typography>
              <Typography variant="body2">{valores.almaCanos?.map((almaCano) => almaCano?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>COMPRIMENTO DO CANO</b>
              </Typography>
              <Typography variant="body2">{valores.comprimentoCano || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>ESTADO DE CONSERVAÇÃO</b>
              </Typography>
              <Typography variant="body2">{valores.estadoConservacao?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>OUTRAS CARACTERÍSTICAS</b>
              </Typography>
              <Typography variant="body2">{valores.outrasCaracteristicas?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
          </Grid>
        </>
      )}

      {tipoVestigioGenerico === 'BALISTICO' && (tipoVestigioEspecifico === 'CARTUCHO' || tipoVestigioEspecifico === 'ESTOJO') && (
        <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>INFORMAÇÕES TÉCNICAS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '15px' }}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          {tipoExame === 'CONFRONTO_BALISTICO' && (
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>IDENTIFICADOR</b>
              </Typography>
              <Typography variant="body2">{valores.outrasCaracteristicas ? `${valores.outrasCaracteristicas?.toUpperCase()}` : 'NÃO INFORMADO'}</Typography>
            </Grid>
          )}
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>UNIDADES</b>
            </Typography>
            <Typography variant="body2">{dadosDescricaoTecnicaPai ? dadosDescricaoTecnicaPai.unidades : valores.unidades.toString() || 'NÃO INFORMADO'}</Typography>
          </Grid>

          {tipoVestigioEspecifico === 'CARTUCHO' && (
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>UNIDADES TESTADAS</b>
              </Typography>
              <Typography variant="body2">{dadosDescricaoTecnicaPai ? dadosDescricaoTecnicaPai.unidadesConsumidas : valores.unidadesConsumidas.toString() || 'NÃO INFORMADO'}</Typography>
            </Grid>
          )}
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CALIBRE NOMINAL</b>
            </Typography>
            <Typography variant="body2">{valores.calibreNominal?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>VARIAÇÃO</b>
            </Typography>
            <Typography variant="body2">{valores.calibreVariacao?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>FABRICANTE</b>
            </Typography>
            <Typography variant="body2">{valores.fabricante?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CÁPSULA DE ESPOLETAMENTO</b>
            </Typography>
            <Typography variant="body2">{valores.capsulaEsps?.map((capsula) => capsula?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>ESTOJO</b>
            </Typography>
            <Typography variant="body2">{valores.tipoEstojos?.map((tipoEstojo) => tipoEstojo?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>
          
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>ANO DE FABRICAÇÃO</b>
            </Typography>
            <Typography variant="body2">{valores.gravacoesInput || 'NÃO INFORMADO'}</Typography>
          </Grid>

          {tipoVestigioEspecifico === 'CARTUCHO' && (
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>PROJÉTIL</b>
              </Typography>
              <Typography variant="body2">{valores.tiposProjetil?.map((tipoProjetil) => tipoProjetil?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
            </Grid>
          )}

          {tipoExame === 'IDENTIFICACAO_BALISTICA' && tipoVestigioEspecifico === 'ESTOJO' && (
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>FORMATO PERCUTOR</b>
              </Typography>
              <Typography variant="body2">{valores.formatoPercutor?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
            </Grid>
          )}

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>NÚMERO DE LOTE</b>
            </Typography>
            <Typography variant="body2">{valores.numeroLote?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
        </Grid>
      )}
      {tipoVestigioGenerico === 'BALISTICO' && tipoVestigioEspecifico === 'ELEMENTO_MUNICAO' && (
        <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>INFORMAÇÕES TÉCNICAS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '15px' }}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>ELEMENTO DE MUNIÇÃO</b>
            </Typography>
            <Typography variant="body2">
              {valores.tipo?.toUpperCase() || 'NÃO INFORMADO'}
              {tipoExame === 'CONFRONTO_BALISTICO' && valores.outrasCaracteristicas ? ` - ${valores.outrasCaracteristicas?.toUpperCase()}` : ''}
            </Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>TIPO</b>
            </Typography>
            <Typography variant="body2">{valores.tiposProjetil?.map((tipoProjetil) => tipoProjetil?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>RESSALTOS E CAVADOS</b>
            </Typography>
            <Typography variant="body2">{valores.ressaltosCavados?.map((rc) => rc?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>TIPO DO RAIAMENTO</b>
            </Typography>
            <Typography variant="body2">{valores.tiposRaiamentos?.map((tr) => tr?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>MASSA</b>
            </Typography>
            <Typography variant="body2">{valores.medidaMassa?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>DIÂMETRO</b>
            </Typography>
            <Typography variant="body2">{valores.medidaDiametro?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>COMPRIMENTO</b>
            </Typography>
            <Typography variant="body2">{valores.medidaComprimento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CALIBRE COMPATÍVEL</b>
            </Typography>
            <Typography variant="body2">{valores.calibreCompativel?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
        </Grid>
      )}

      {tipoVestigioGenerico === 'BALISTICO' && tipoVestigioEspecifico === 'ELEMENTO_RECARGA' && (
        <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>INFORMAÇÕES TÉCNICAS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '15px' }}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>TIPO</b>
            </Typography>
            <Typography variant="body2">{valores.tipo?.id ? valores.tipo.nome?.toUpperCase() : valores.tipo || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CARACTERÍSTICAS</b>
            </Typography>
            <Typography variant="body2">{valores.outrasCaracteristicas || 'NÃO INFORMADO'}</Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>EMBALAGEM PRIMÁRIA</b>
            </Typography>
            <Typography variant="body2">{valores.embalagemPrimaria || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>QUANTIDADE</b>
            </Typography>
            <Typography variant="body2">
              {valores.quantidade || 'NÃO INFORMADO'} {valores.unidadeQuantidade || ''}
            </Typography>
          </Grid>
        </Grid>
      )}

      {tipoVestigioGenerico === 'BALISTICO' && tipoVestigioEspecifico === 'CARREGADOR' && (
        <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>INFORMAÇÕES TÉCNICAS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '15px' }}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Grid item md={4} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>UNIDADES</b>
              </Typography>
              <Typography variant="body2">{dadosDescricaoTecnicaPai ? dadosDescricaoTecnicaPai.unidades : valores.unidades}</Typography>
            </Grid>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>TIPO</b>
            </Typography>
            <Typography variant="body2">{valores.tipo?.id ? valores.tipo.nome?.toUpperCase() : valores.tipo.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CAPACIDADE DO CARREGADOR</b>
            </Typography>
            <Typography variant="body2">{valores.capacidade || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>CALIBRE NOMINAL</b>
            </Typography>
            <Typography variant="body2">{valores.calibreNominal || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>MODELO</b>
            </Typography>
            <Typography variant="body2">{valores.modelo?.id ? valores.modelo.nome?.toUpperCase() : valores.modelo?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>LOCAL DE FABRICAÇÃO</b>
            </Typography>
            <Typography variant="body2">{valores.locFabs?.map((locFab) => locFab?.nome?.toUpperCase()).join(', ') || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>OUTRAS CARACTERÍSTICAS</b>
            </Typography>
            <Typography variant="body2">{valores.outrasCaracteristicas?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
          </Grid>
        </Grid>
      )}

      {tipoVestigioGenerico === 'QUIMICO' && (
        <>
          <Grid item md={12} sm={12} xs={12}>
            <Typography>
              <b>QUANTIFICAÇÃO</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>UNIDADES</b>
              </Typography>
              <Typography variant="body2">{dadosDescricaoTecnicaPai ? dadosDescricaoTecnicaPai.unidades : valores.unidades}</Typography>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>QUANTIDADE</b>
              </Typography>
              <Typography variant="body2">
                {valores.quantidade} {valores.unidadeQuantidade}
              </Typography>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>QUANTIDADE DE CONTRAPROVA</b>
              </Typography>
              <Typography variant="body2">
                {valores.quantidadeContraprova} {valores.unidadeQuantidadeContraprova}
              </Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>GEROU ANEXO</b>
              </Typography>
              <Typography variant="body2">{!valores.anexo || valores.anexo === 'NAO' ? 'NÃO' : `SIM - LACRE ANEXO: ${valores.lacreAnexo}`}</Typography>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  )
}
